import { render } from "./Subscription.vue?vue&type=template&id=50bfaac7&scoped=true&ts=true"
import script from "./Subscription.vue?vue&type=script&lang=ts"
export * from "./Subscription.vue?vue&type=script&lang=ts"

import "./Subscription.vue?vue&type=style&index=0&id=50bfaac7&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bfaac7"]])

export default __exports__